import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {CityReducerType, SearchCityParams} from "./Types";
import City from "../../Models/City";
import {arrayToOptions} from "../../Utils/Utils";

const initialState: CityReducerType = {
  cities: [],
  cityOptionList: []
};

const CitySlice = createSlice({
  name: "City",
  initialState,
  reducers: {
    getCities(state, action : PayloadAction<SearchCityParams> ) {},
    setCities(state: any, { payload }: PayloadAction<City[]>) {
      state.cities = payload;
      state.cityOptionList = arrayToOptions(payload,'_KEY','name');
    },
    deleteCity(state, {payload} : PayloadAction <any> ) {},
    saveCity(state, {payload} : PayloadAction <any> ) {},
  }
});

export const CityActions = CitySlice.actions;

export default CitySlice.reducer
